@import '../../assets/styles/components.css';

@layer components {
  :host {
    @apply absolute opacity-0 p-3 -z-[1];

    &([open]) {
      @apply delay-150 duration-150 ease-out opacity-100 transition-opacity z-[1];
    }

    .inner-container {
      @apply relative rounded;
      @apply max-w-xs w-max;
      @apply px-3 py-2;
      @apply bg-brand-700 text-neutral-lightest;
      @apply leading-4 text-2xs;
      @apply drop-shadow-md;
    }

    .nub {
      @apply absolute rotate-45 -z-[1];
      @apply h-4 w-4;
      @apply bg-brand-700;
    }
  }
}
